import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Alert,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import api from "../api";

const Auditoria = () => {
  const hoje = new Date();
  const [ano, setAno] = useState(hoje.getFullYear());
  const [usuarios, setUsuarios] = useState([]);
  const [auditoriaData, setAuditoriaData] = useState([]);
  const [mensagem, setMensagem] = useState("");

  useEffect(() => {
    const fetchAuditoriaData = async () => {
      try {
        const response = await api.get(`/lancamentos/auditoria/${ano}`);
        const data = response.data;

        if (data.length === 0) {
          setMensagem("Não há dados registrados para o ano selecionado.");
          setAuditoriaData([]);
        } else {
          setMensagem("");
          setAuditoriaData(data);
        }
      } catch (error) {
        console.error("Erro ao buscar dados da auditoria:", error);
        setMensagem("Erro ao carregar os dados da auditoria.");
      }
    };

    fetchAuditoriaData();
  }, [ano]);

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const response = await api.get("/usuarios");
        const usuariosEstado = response.data
          .filter((usuario) => usuario.perfil === "ESTADO")
          .sort((a, b) => {
            const suffixA = a.nome.slice(-2);
            const suffixB = b.nome.slice(-2);
            return suffixA.localeCompare(suffixB);
          });
        setUsuarios(usuariosEstado);
      } catch (error) {
        console.error("Erro ao buscar usuários:", error);
        setMensagem("Erro ao carregar os usuários.");
      }
    };

    fetchUsuarios();
  }, []);

  const anosPermitidos = Array.from(
    { length: hoje.getFullYear() - 2020 + 1 },
    (_, i) => hoje.getFullYear() - i
  );

  return (
    <Box sx={{ padding: 4 }}>
      <Typography
        variant="h4"
        mb={3}
        sx={{ textAlign: "center", fontWeight: "bold" }}
      >
        Auditoria de Lançamentos
      </Typography>

      <FormControl fullWidth variant="outlined" sx={{ mb: 3 }}>
        <InputLabel id="ano-label">Ano</InputLabel>
        <Select
          labelId="ano-label"
          value={ano}
          onChange={(e) => setAno(e.target.value)}
          label="Ano"
        >
          {anosPermitidos.map((anoPermitido) => (
            <MenuItem key={anoPermitido} value={anoPermitido}>
              {anoPermitido}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {mensagem && (
        <Alert severity="info" sx={{ mb: 3 }}>
          {mensagem}
        </Alert>
      )}

      {!mensagem && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                  Usuário
                </TableCell>
                {Array.from({ length: 12 }, (_, i) => (
                  <TableCell
                    key={i}
                    align="center"
                    sx={{ fontWeight: "bold", textTransform: "capitalize" }}
                  >
                    {new Date(0, i).toLocaleString("pt-BR", { month: "short" })}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {usuarios.map((usuario) => (
                <TableRow key={usuario.id}>
                  <TableCell>{usuario.nome}</TableCell>
                  {Array.from({ length: 12 }, (_, mes) => {
                    const lancamentoMes = auditoriaData.find(
                      (dado) =>
                        dado.usuarioId === usuario.id && dado.mes === mes + 1
                    );

                    return (
                      <TableCell key={mes} align="center">
                        {lancamentoMes?.completo ? (
                          <CheckCircleIcon color="success" />
                        ) : (
                          <CancelIcon color="error" />
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default Auditoria;
